<template>
    <!-- 对话框 -->

    <el-dialog title="编辑企业" :visible.sync="show" :before-close="closeDialog" width="80%">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="100px" style="overflow-y: auto; height: 50vh; margin-top: 20px">
                    <div>
                        <div class="main-wrap clearfix">
                            <div>
                                <el-form-item label="企业名称:">
                                    <el-input
                                        v-model="submit_data.name"
                                        :placeholder="submit_rules.name.placeholder"
                                        style="width: 200px; margin-right: 5px"
                                    >
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="企业合同:">
                                    <div style="display: flex">
                                        <div class="image-heTong" v-for="(item, index) in srcList" :key="index">
                                            <el-image
                                                :ref="'elImage' + index"
                                                :initial-index="initial_index"
                                                :preview-src-list="logicImageList"
                                                :src="item.url"
                                                class="avatar"
                                            ></el-image>
                                            <div class="delete">
                                                <i class="el-icon-zoom-in" @click="previewImg(index)"></i>
                                                <i class="el-icon-delete" @click="subImg(index)"></i>
                                            </div>
                                        </div>

                                        <el-upload
                                            class="avatar-uploader picture-card"
                                            v-if="srcList.length < 4"
                                            :show-file-list="false"
                                            action=""
                                            list-type="picture-card"
                                            :before-upload="heTongSuccess"
                                            :headers="img_headers"
                                            v-loading="uploadLoading"
                                        >
                                            <i class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </div>
                                </el-form-item>

                                <el-form-item label="企业管理员:">
                                    <el-input v-model="submit_data.admin_name" style="width: 200px; margin-right: 5px"> </el-input>
                                </el-form-item>
                                <el-form-item label="管理员电话:">
                                    <el-input v-model="submit_data.admin_phone" maxlength="11" style="width: 200px; margin-right: 5px">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="订单模式:">
                                    <el-select
                                        v-model="value_mode_code"
                                        placeholder="请选择模式"
                                        @visible-change="modeVisibleChange"
                                        @change="modeChange"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option
                                            v-for="item in options_mode_code"
                                            :key="item.value"
                                            :label="item.order_mode.name"
                                            :value="item.order_mode.order_mode_code"
                                        >
                                        </el-option>

                                        <el-pagination
                                            class="pagination"
                                            layout="prev, pager, next"
                                            :total="selectPages_data.count"
                                            :page-size="mode_options_data.limit"
                                            @current-change="selectPages_function"
                                            :current-page="mode_options_data.page"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="true"
                        @toJSON="toJSON"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },

    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.submit_data.name = _this.data.name;
            _this.submit_data.store_code = _this.data.store_code;
            _this.submit_data.contract_hash_1 = _this.data.contract_hash_1;
            _this.submit_data.contract_hash_2 = _this.data.contract_hash_2;
            _this.submit_data.contract_hash_3 = _this.data.contract_hash_3;
            _this.submit_data.contract_hash_4 = _this.data.contract_hash_4;

            _this.submit_data.admin_name = _this.data.admin_name;
            _this.submit_data.admin_phone = _this.data.admin_phone;
            _this.submit_data.order_mode_code = _this.data.order_mode.order_mode_code;
            _this.submit_data.store_admin_code = _this.data.store_admin_code;
            _this.value_mode_code = _this.data.order_mode.name;
            if (_this.data.contract_hash_1_url != '') {
                _this.srcList.push({ hash: String(_this.data.contract_hash_1), url: String(_this.data.contract_hash_1_url) });
            }

            if (_this.data.contract_hash_2_url != '') {
                _this.srcList.push({ hash: String(_this.data.contract_hash_2), url: String(_this.data.contract_hash_2_url) });
            }
            if (_this.data.contract_hash_3_url != '') {
                _this.srcList.push({ hash: String(_this.data.contract_hash_3), url: String(_this.data.contract_hash_3_url) });
            }
            if (_this.data.contract_hash_4_url != '') {
                _this.srcList.push({ hash: String(_this.data.contract_hash_4), url: String(_this.data.contract_hash_4_url) });
            }
        }
    },

    data() {
        return {
            initial_index: 0,
            logicImageList: [],
            // 禁用上传组件
            uploadLoading: false,
            submit_url: 'store/editStoreSubmit',
            value_mode_code: '',
            options_mode_code: [],
            selectPages_data: [],
            selectPages_function(val) {
                _this.mode_options_data.page = val;
                console.log(_this.mode_options_data);
                _this.orderModeList();
            },
            show: false,
            mode_options_data: {
                page: 1,
                limit: 5,
                status: '1'
            },

            // 图片上传地址
            img_upload_url: '',

            srcList: [],

            // 表单数据
            submit_data: {
                name: '',
                store_code: '',
                contract_hash_1: '',
                contract_hash_2: '',
                contract_hash_3: '',
                contract_hash_4: '',
                admin_name: '',
                admin_phone: '',
                order_mode_code: '',
                store_admin_code: ''
            },

            submit_rules: {
                name: {
                    placeholder: '企业名称需在50字之内',
                    rules: {
                        required: true,
                        message: '企业名称需在50字之内',
                        regulation: 'elt_str',
                        rulesData: 50
                    }
                },

                contract_hash_1: {
                    placeholder: '合同照片',
                    rules: {
                        required: false,
                        message: '合同照片哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                contract_hash_2: {
                    placeholder: '合同照片',
                    rules: {
                        required: false,
                        message: '合同照片哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                contract_hash_3: {
                    placeholder: '合同照片',
                    rules: {
                        required: false,
                        message: '合同照片哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                contract_hash_4: {
                    placeholder: '合同照片',
                    rules: {
                        required: false,
                        message: '合同照片哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },

                admin_name: {
                    placeholder: '管理员姓名需在2-8字之内',
                    rules: {
                        required: true,
                        message: '管理员姓名需在2-8字之内',
                        regulation: 'between_str',
                        rulesData: [2, 8]
                    }
                },

                admin_phone: {
                    placeholder: '管理员电话',
                    rules: {
                        required: true,
                        message: '管理员电话长度不正确',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                order_mode_code: {
                    placeholder: '订单模式',
                    rules: {
                        required: true,
                        message: '订单模式错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                }
            },
            // 上传图片的请求头
            img_headers: {
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'city-tag': localStorage.getItem('city_tag'),
                'service-tag':localStorage.getItem('service_tag')
            }
        };
    },

    created() {
        _this = this;
    },
    methods: {
        previewImg(index) {
            _this.logicImageList = _this.srcList.map((item) => {
                return item.url;
            });
            _this.initial_index = index;
            _this.$nextTick(() => {
                _this.$refs['elImage' + index][0].clickHandler();
            });
        },
        toJSON() {
            for (let i = 0; i < _this.srcList.length; i++) {
                if (_this.srcList[i].hash) {
                    _this.submit_data['contract_hash_' + (i + 1)] = _this.srcList[i].hash;
                }
            }
        },
        // 更换图片按钮方法
        subImg(index) {
            _this.srcList.splice(index, 1);
        },

        // 照片上传成功后执行 两个参数，file代表上传的文件，isSave代表上传的policyName参数是临时文件还是永久文件。permanent（永久文件）temporary（临时文件）
        heTongSuccess(file) {
            _this.uploadLoading = true;
            _this.$uploadImage({ file: file, isSave: 'permanent' }).then((res) => {
                _this.srcList.push({
                    url: String(URL.createObjectURL(file)),
                    hash: res.hash
                });
                _this.uploadLoading = false;
            });

            return false;
        },

        modeVisibleChange(val) {
            _this.orderModeList();
        },
        orderModeList() {
            _this
                .$post('/order/orderModeLists', _this.mode_options_data)
                .then((res) => {
                    _this.selectPages_data = res;
                    _this.options_mode_code = res.data;
                    console.log(_this.options_mode_code, '_this.options_mode_code=--');
                })
                .catch((err) => {});
        },
        modeChange(val) {
            for (let i = 0; i < this.options_mode_code.length; i++) {



                if (this.options_mode_code[i].order_mode.order_mode_code == val) {


                    _this.value_mode_code = this.options_mode_code[i].order_mode.name;
                }
            }

            _this.submit_data.order_mode_code = val;
        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.value_mode_code = '';
            _this.options_mode_code = [];
            _this.selectPages_data = [];
            _this.srcList = [];
            _this.logicImageList = [];
            _this.initial_index = 0;
            _this.uploadLoading = false;

            _this.mode_options_data = {
                page: 1,
                limit: 5,
                status: '1'
            };

            _this.img_upload_url = '';
            _this.submit_data = {
                name: '',
                store_code: '',
                contract_hash_1: '',
                contract_hash_2: '',
                contract_hash_3: '',
                contract_hash_4: '',
                admin_name: '',
                admin_phone: '',
                order_mode_code: '',
                store_admin_code: ''
            };
        },
        // 提交按钮的请求方法
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>
<style>
.picture-card {
    display: flex;
    width: 100% !important;
    height: auto !important;
    flex-wrap: wrap;
}
.picture-card .el-upload-list {
    display: flex;
    flex-wrap: wrap;
}

.picture-card .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
}
.picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
}
.hide.avatar-uploader .el-upload {
    display: none !important;
}
</style>
<style scoped>
.image-heTong {
    margin-right: 10px;
    position: relative;
}
.image-heTong:hover .delete {
    display: block;
}
.delete {
    position: absolute;
    width: 100px;
    height: 100px;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    text-align: center;
    line-height: 100px;
    top: 0;
    left: 0;
}
.el-icon-delete,
.el-icon-zoom-in {
    color: #fff;
    font-size: 20px;
}
.el-icon-zoom-in {
    margin-right: 15px;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    height: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.verify_remarks {
    font-size: 14px;
    color: #606266;
}
</style>
